export const VELOCITYLIMITCONDITIONS = [
    {
        "code": "CARD_TYPE",
        "description": "Type of card",
        "regex": "^(VIRTUAL|PHYSICAL|BOTH)$",
        "type": "text",
        "values": ['VIRTUAL','PHYSICAL','BOTH']
    },
    {
        "code": "MCC",
        "description": "Merchant Category Code",
        "type": "text",
        "regex": "^([0-9]{4,4})$",
        "values": []
    },
    {
        "code": "MERCHANT_ID",
        "description": "Merchant Id",
        "type": "text",
        "regex": "^([0-9]{8,15})$",
        "values": []
    },
    {
        "code": "ACQUIRER_COUNTRY",
        "description": "From where the transaction was initiated",
        "type": "text",
        "regex": "^([A-Z]{3,3})$",
        "values": []
    },
    {
        "code": "CHANNEL_SCOPE",
        "description": "Payment Scheme",
        "type": "text",
        "regex": "^(VISA|MASTERCARD|MERCURY|UNIONPAY)$",
        "values": ['VISA','MASTERCARD','MERCURY','UNIONPAY']
    },
    {
        "code": "KYC_LEVEL",
        "description": "Cardholder KYC Level",
        "type": "text",
        "regex": "",
        "values": []
    },
    {
        "code": "TRANSFER_TYPE",
        "description": "TRANSFER TYPE",
        "type": "text",
        "regex": "^([A-Z]{3,3})$",
        "values": []
    },
    {
        "code": "PURCHASE_TYPE",
        "description": "PURCHASE TYPE ECOMMERCE or PURCHASE",
        "type": "text",
        "regex": "^(ECOMMERCE|PURCHASE)",
        "values": ['ECOMMERCE','PURCHASE']
    }
]